import Reveal from '@/components/base/Reveal';

interface Rule {
  index: string;
  label: string;
  detail: string;
  value: string;
  tone?: 'primary' | 'default';
}

const rules: Rule[] = [
  {
    index: '01',
    label: 'Protective Stop',
    detail: 'Attached the moment the position opens',
    value: 'ON ENTRY',
  },
  {
    index: '02',
    label: 'Trailing Stop',
    detail: 'Advances behind price as the trade moves into profit',
    value: 'TRAILING',
    tone: 'primary',
  },
  {
    index: '03',
    label: 'Take Profit',
    detail: 'A defined target where the position is closed into strength',
    value: 'TARGET',
  },
  {
    index: '04',
    label: 'Time Exit',
    detail: 'Closed if it has not resolved within its holding window',
    value: 'MAX HOLD',
  },
];

function TradeManagement() {
  return (
    <section
      id="trade-management"
      className="w-full scroll-mt-[124px] border-y border-background-200 bg-background-100 px-4 md:px-8 lg:px-12 py-16 md:py-24"
    >
      <div className="max-w-[1440px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <Reveal className="lg:order-2">
          <div className="flex items-center gap-3 mb-5">
            <span className="text-[11px] font-data tracking-[0.24em] text-primary-600">
              STRATEGY
            </span>
            <span className="w-8 h-px bg-primary-400"></span>
            <span className="text-[11px] font-data tracking-[0.2em] text-foreground-400">
              MANAGING THE TRADE
            </span>
          </div>
          <h2 className="font-heading font-extrabold tracking-tight text-foreground-950 text-[32px] leading-[1.08] sm:text-[42px] lg:text-[46px]">
            The Exit Is Planned Before The Entry.
          </h2>
          <p className="mt-5 text-[15px] md:text-base leading-relaxed text-foreground-600 max-w-[540px]">
            A position is never opened without its exit already defined. The moment a trade is
            filled, three things are attached in the same action: a protective stop, a take-profit
            target and a trailing mechanism.
          </p>
          <p className="mt-4 text-[14px] leading-relaxed text-foreground-500 max-w-[540px]">
            From there the trade is managed by rule until it closes. It is not held on hope — a
            position only stays open while it keeps behaving the way it was taken for.
          </p>
        </Reveal>

        <Reveal delay={140} className="lg:order-1">
          <div className="rounded-lg border border-background-300 bg-background-50 overflow-hidden">
            <div className="flex items-center justify-between px-5 h-12 border-b border-background-200 bg-background-100">
              <span className="text-[12px] font-data tracking-widest text-foreground-700">
                POSITION RULES
              </span>
              <span className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-primary-500 breathe"></span>
                <span className="text-[10px] font-data tracking-widest text-primary-600">
                  ALWAYS ACTIVE
                </span>
              </span>
            </div>

            <div className="divide-y divide-background-200">
              {rules.map((rule) => (
                <div key={rule.index} className="flex items-center gap-3 px-5 py-4">
                  <span className="w-6 shrink-0 font-data text-[11px] text-foreground-400">
                    {rule.index}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="text-[13px] font-semibold text-foreground-900">{rule.label}</p>
                    <p className="text-[11.5px] leading-snug text-foreground-500">{rule.detail}</p>
                  </div>
                  <span
                    className={`shrink-0 inline-flex items-center gap-1.5 font-data text-[10px] tracking-widest ${
                      rule.tone === 'primary' ? 'text-primary-700' : 'text-foreground-500'
                    }`}
                  >
                    {rule.tone === 'primary' && (
                      <span className="w-1.5 h-1.5 rounded-full bg-primary-500 breathe"></span>
                    )}
                    {rule.value}
                  </span>
                </div>
              ))}
            </div>

            <div className="flex items-center justify-between border-t border-background-200 bg-background-100 px-5 py-3">
              <span className="text-[10px] font-data tracking-widest text-foreground-400">
                XAUUSD · AUTOMATED
              </span>
              <span className="text-[10px] font-data tracking-widest text-foreground-500">
                NO MANUAL STEP
              </span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export default TradeManagement;